var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPeopleIconRoom(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 13,
    viewBox: "0 0 15 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.3035 12V10.7778C14.3031 10.2362 14.1229 9.71003 13.791 9.28197C13.4592 8.85392 12.9946 8.54818 12.4702 8.41278",
    stroke: "#BCBCBC",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0256 1.08011C10.5514 1.21474 11.0175 1.52054 11.3503 1.9493C11.6831 2.37806 11.8638 2.90539 11.8638 3.44816C11.8638 3.99093 11.6831 4.51826 11.3503 4.94702C11.0175 5.37578 10.5514 5.68158 10.0256 5.81621",
    stroke: "#BCBCBC",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7778 12V10.7778C10.7778 10.1295 10.5202 9.5077 10.0618 9.04928C9.60338 8.59086 8.98162 8.33332 8.33332 8.33332H3.44444C2.79613 8.33332 2.17438 8.59086 1.71596 9.04928C1.25754 9.5077 1 10.1295 1 10.7778V12",
    fill: "#BCBCBC",
    stroke: "#BCBCBC",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.88902 5.88888C7.23905 5.88888 8.33346 4.79447 8.33346 3.44444C8.33346 2.09441 7.23905 1 5.88902 1C4.53899 1 3.44458 2.09441 3.44458 3.44444C3.44458 4.79447 4.53899 5.88888 5.88902 5.88888Z",
    fill: "#BCBCBC",
    stroke: "#BCBCBC",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeopleIconRoom);
export default __webpack_public_path__ + "static/media/PeopleIcon_Room.fa94c8a7.svg";
export { ForwardRef as ReactComponent };